import type { Availability } from '@shared/types/types.ts';

/**
 *
 *
 *
 *
 */
export function resolveDeliveryText(
    availability: Availability | undefined,
    deliveryDateExperimentActive: boolean,
): string | null | undefined {
    const detailDate = availability?.detailDate;
    return deliveryDateExperimentActive && detailDate?.trim() ? detailDate : availability?.detail;
}
